import axios from '@/plugins/axios';

export function unifiedorder(params) {
  return axios.post('/weixin/pay/unifiedorder', {
    body: params.body,
    outTradeNo: params.outTradeNo,
    productId: params.productId,
    couponCode: params.couponCode
  });
}

/**
 * 获取订单的支付状态
 * @param outTradeNo
 */
export function getOrderStatus(outTradeNo) {
  return axios.get('/weixin/pay/getOrderStatus', {
    params: {
      outTradeNo: outTradeNo
    }
  });
}

export function saveConfirmFlag(params) {
  return axios.post('/weixin/saveConfirmFlag', {
    confirmType: params.confirmType,
    confirmMsg: params.confirmMsg,
    confirmUserId: params.confirmUserId
  });
}

export function getConfirmStatus(storeKey) {
  return axios.get('/weixin/getConfirmStatus', {
    params: {
      storeKey: storeKey
    }
  });
}

export function wxLogin(storeKey) {
  return axios.get('/weixin/wxLogin', {
    params: {
      storeKey: storeKey
    }
  });
}
export function getWxBindInfoByStoreKey(storeKey) {
  return axios.get('/weixin/getWxBindInfoByStoreKey', {
    params: {
      storeKey: storeKey
    }
  });
}
export function wxBind(params) {
  return axios.post('/weixin/wxBind', params);
}
